export const filterEmptyValues = <T extends Record<string, any>>(params: T): T => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([_key, value]) => value !== null && value !== undefined && value !== ''
    )
  ) as T;
};
